export default {
  asset: {
    upload: {
      errorType: '文件类型{type}不允许上传',
      errorFileSize: '文件大小超过限制，最大不能超过{size}',
      errorFileDirection: '文件比例不一致',
      label: '上传创意资产',
      describe: '拖放文件即可立即上传',
      rules:
        '视频：mp4/avi/mkv/flv/mov/webm\n图片：jpg/png/gif\n音频：mp3/aac/wav\n其他：psd/zip',
      imageRules: '图片',
      videoRules: '视频',
      audioRules: '音频',
      otherRules: '其他',
      selectall: '全选',
      selected: '已选 {selectNum} 项',
      capacity: '储存空间',
      filetips: '文件存在重名，请重新命名',
      exists: '文件已存在',
      describing: '{successNum} / {selectNum} 文件已上传',
      success: '{successNum} 个文件全部上传成功。',
      total: ' {failNum} 个文件上传失败， {successNum} 个文件上传成功。',
      completed: '上传完成',
      failed: '上传失败',
      fontRules: '字体',
    },
    label: '创意资产',
    download: {
      maxDownload: '不允许下载文件超过500M',
      filePack: '文件打包中',
      fileDownload: '文件下载中',
    },
    rules: {
      nameNoSpecialCharacter: '名称不支持特殊字符',
      nameNoEmpty: '名称不能为空',
      success: '编辑成功',
    },
    table: {
      describe:
        '· 若资产已被项目使用，删除资产会影响项目编辑。<br/>· 若资产包括录屏文件，录屏文件不能直接删除，若想删除录屏文件，需要删除相关录屏项目。<br/>· 此操作不可恢复，请确认。',
      name: '资产名称及ID',
      assetssource: '来源',
      assetstype: '类型',
      format: '格式',
      size: '大小',
      updatetime: '更新时间',
      batch: {
        delete: {
          label: '删除 {num} 项资产',
          describe:
            '若资产已被项目使用，删除会影响项目编辑。<br/>若资产包括录屏工程文件，此文件不能直接删除；若想删除此文件，需要删除相关录屏项目。<br/>删除后将无法恢复，确定删除吗？',
        },
        download: {
          label: '下载文件',
          selected: '已选中 2 个文件项',
          total: '文件大小共 {fileSize}',
          forbidTip: '转码失败无法下载',
        },
      },
      status: '转码状态',
      operation: {
        editName: '编辑资产名称',
        rename: '重命名',
        ai: 'AI视频编辑',
        video: '视频编辑',
        videoDisableTip: '支持 mp4、mov 格式，大小不超过500MB。',
      },
    },
    describe:
      '统一管理创意工具（视频/录屏/可玩）编辑中需要使用的各类创意资产。',
    tab: {
      label: '创意资产',
    },
    uploading: '正在上传',
    creating: '正在上传',
    filter: {
      assetname: '资产名称',
      assetid: '资产ID',
      createtime: '创建时间',
      updatetime: '更新时间',
      size: '文件大小',
      format: '格式',
      audio: '音频',
      image: '图片',
      video: '视频',
      other: '其他',
      types: '类型',
      h5: 'H5',
      font: '字体',
      psd: 'PSD',
      zip: '压缩文件',
      recordfile: '录屏工程文件',
    },
    advanced: {
      tips: '高级筛选',
      direction: '方向',
      horizontal: '横',
      vertical: '竖',
      square: '方',
      proportion: '比例',
      duration: '时长',
      second: '秒',
      minute: '分',
      hour: '小时',
      code: '码率',
      frame: '帧率',
      filesize: '大小',
      size: '尺寸',
      date: '日期',
      createdate: '创建日期',
      updatedate: '更新日期',
      nowadays: '今天',
      last7days: '最近一周',
    },
    result: '结果',
    gridtips: '卡片视图',
    listtips: '列表视图',
    multiple: '多选',
    details: {
      message: '资产详情',
      name: '资产名称',
      placeholder: '请输入资产名称',
      description: '描述',
      desplaceholder: '请输入描述信息',
      source: '来源',
      type: '类型',
      label: '标签',
      folder: '文件夹',
      founder: '创建人',
      lastupdated: '最后更新人',
      updatedtime: '更新时间',
      information: '文件信息',
    },
    transcode: {
      transcoding: '转码中',
      error: '转码失败',
      active: '转码成功',
    },
  },
}
